<template>
  <div class="">
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div class="new">
      <div class="main-content pc">
        <div style="width: 100%; line-height: 30px; margin-top: 40px">
          <div class="big-title">
            <div class="big-name">
              <span class="line-left"></span>
              <span class="txt" style="font-size: 29px; font-weight: bold"
                >医院资讯</span
              >
              <span class="line-right"></span>
            </div>
          </div>
        </div>
        <div style="display: flex; margin-top: 50px">
          <div
            style="width: 100%"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
          >
            <el-empty
              description="暂无动态"
              v-if="newList.length === 0"
            ></el-empty>
            <div
              class="new-Bar showList"
              v-for="(item, index) of newList"
              :key="index"
            >
              <div
                style="
                  width: 100%;
                  margin: 0 auto;
                  padding: 0px 0 10px;
                  border-radius: 5px;
                "
              >
                <!-- :src="item.images" -->
                <img
                  :src="item.images !== '' ? item.images : bg"
                  alt=""
                  style="width: 100%; height: 270px; border-radius: 5px 5px 0 0"
                />
              </div>
              <div class="bd-holder"></div>
              <div class="bd-content">
                <div class="content-image">
                  <img
                    src="../../assets/icon-nc.svg"
                    alt=""
                    style="width: 100%"
                  />
                </div>
                <div
                  class="new-title lishu"
                  style="text-align: center"
                  :title="item.title"
                >
                  <h3>{{ item.title }}</h3>
                </div>
                <div class="new-content" style="">
                  {{ item.abstract }}
                </div>
              </div>
              <div
                style="
                  text-align: center;
                  position: absolute;
                  bottom: 30px;
                  width: 100%;
                "
              >
                <el-button size="small" class="getMore" @click="go(item.id)">
                  了解更多
                </el-button>
              </div>
            </div>
          </div>
          <div style="width: 14%; margin-left: 30px">
            <div class="list-tit">
              <div>
                <span>就医指南</span>
              </div>
            </div>
            <div
              class="flex-center jiuyi"
              style="background: #7ecef4"
              @click="goGuide(1)"
            >
              <img
                src="../../assets/mzbg.png"
                alt=""
                style="width: 30px; margin-right: 10px"
              />
              <div>防疫指南</div>
            </div>
            <div
              class="flex-center jiuyi"
              style="background: #facd89"
              @click="goGuide(2)"
            >
              <img
                src="../../assets/jylc.png"
                alt=""
                style="width: 30px; margin-right: 10px"
              />
              <div>就医流程</div>
            </div>
            <div
              class="flex-center jiuyi"
              style="background: #cce198"
              @click="goyuyue"
            >
              <img
                src="../../assets/yygh.png"
                alt=""
                style="width: 30px; margin-right: 10px"
              />
              <div>快速挂号</div>
            </div>
            <div
              class="flex-center jiuyi"
              style="background: #f19ec2"
              @click="copyPhone()"
            >
              <img
                src="../../assets/zxjz.png"
                alt=""
                style="width: 30px; margin-right: 10px"
              />
              <div>在线导诊</div>
            </div>
            <div class="list-tit">
              <div>
                <span>视频资讯</span>
              </div>
            </div>
            <div style="margin-top: 20px">
              <div
                class="videoBar"
                v-for="(item, index) of videoList"
                :key="index"
                @click="goDetail(item.id)"
              >
                <img :src="item.cover_images" alt="" style="width: 100%" />
                <div class="videoBar-title">
                  <div
                    style="
                      position: absolute;
                      bottom: 0;
                      width: 100%;
                      padding: 5px 0;
                      background: rgba(0, 0, 0, 0.4);
                    "
                  >
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
            <!-- <div style="text-align: right;">
            <el-button size="small" class="getMore" style="border:1px solid #439392;" @click="moreVideo">
                了解更多
              </el-button>
          </div> -->

            <div class="flex-center" style="color: #439392" @click="moreVideo">
              <div
                style="
                  flex: 1;
                  text-align: right;
                  letter-spacing: 0px;
                  font-size: 14px;
                "
                class="typeClick"
              >
                更多视频
              </div>
              <img
                src="../../assets/jiantou.png"
                alt=""
                style="width: 16px; margin-left: 5px"
              />
            </div>
          </div>
        </div>
        <el-dialog :visible.sync="showDialog"> </el-dialog>
        <textarea id="input">测试</textarea>
      </div>
      <div class="main-content mobile">
        <div class="big-title" style="margin-bottom: 30px">
          <div class="big-name">医院资讯</div>
          <div class="big-eng">
            <span class="line-left"></span>
            <span class="txt">Hospital Information</span>
            <span class="line-right"></span>
          </div>
        </div>
        <div class="switch-Tab">
          <van-tabs
            v-model="active"
            color="#763a27"
            title-active-color="#763a27"
            style="border-bottom: 1px solid #e5e5e5"
            swipeable
            animated
            @change="switchTab"
          >
            <van-tab title="新闻资讯" title-class="vanTabClass">
              <div>
                <div v-if="newList.length === 0">
                  <van-empty description="暂无资讯" />
                </div>
                <div
                  class="flex-center typeClick showList"
                  style="padding: 0.2rem; border-bottom: 1px solid #e6e6e6"
                  v-for="(item, index) of newList"
                  :key="index"
                  @click="go(item.id)"
                >
                  <img :src="item.images || ''" alt="" style="width: 1.4rem" />
                  <div style="margin-left: 0.2rem">
                    <div
                      style="
                        font-size: 0.14rem;
                        color: #333;
                        -webkit-line-clamp: 1;
                      "
                      class="ellipsis"
                    >
                      {{ item.title || "" }}
                    </div>
                    <div
                      style="
                        color: #666;
                        margin: 0.1rem 0;
                        line-height: 0.2rem;
                        font-size: 0.1rem;
                        -webkit-line-clamp: 3;
                      "
                      class="ellipsis"
                      v-html="item.abstract || ''"
                    ></div>
                    <div style="font-size: 0.1rem; color: #333">
                      {{ parseTime(item.addtime, "{y}-{m}-{d}") }}
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
            <van-tab title="视频资讯" title-class="vanTabClass">
              <div>
                <div v-if="videoList.length === 0">
                  <van-empty description="暂无资讯" />
                </div>
                <div
                  class="flex-center typeClick showList"
                  style="padding: 0.2rem; border-bottom: 1px solid #e6e6e6"
                  v-for="(item, index) of videoList"
                  :key="index"
                  @click="goDetail(item.id)"
                >
                  <img
                    :src="item.cover_images || ''"
                    alt=""
                    style="width: 1.4rem"
                  />
                  <div style="margin-left: 0.2rem">
                    <div
                      style="
                        font-size: 0.14rem;
                        color: #333;
                        -webkit-line-clamp: 2;
                      "
                      class="ellipsis"
                    >
                      {{ item.title || "" }}
                    </div>
                    <div
                      style="
                        color: #666;
                        margin: 0.1rem 0;
                        line-height: 0.2rem;
                        font-size: 0.1rem;
                        -webkit-line-clamp: 3;
                      "
                      class="ellipsis"
                      v-html="item.abstract || ''"
                    ></div>
                    <div style="font-size: 0.1rem; color: #333">
                      {{ parseTime(item.createtime, "{y}-{m}-{d}") }}
                    </div>
                  </div>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import bg from "@/assets/text1.png";
import $ from "jquery";
import { getmenudetail, newslist, guideAndVideo } from "@/api/common";
export default {
  name: "new",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      activeIndex: "news",
      newList: [],
      info: { carousel: "", Mcarousel: "" },
      showDialog: false,
      form: {
        page: 1,
        pageSize: 9,
      },
      bg,
      active: 0,
      total: 0,
      videoList: [],
      guidelist: [],
      loading: false,
    };
  },
  mounted() {
    this.loading = true;
    getmenudetail({ id: 8 }).then((res) => {
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
    });
    newslist(this.form).then((res) => {
      var that = this;
      this.newList = res.data.list;
      that.loading = false;
    });
    guideAndVideo().then((res) => {
      this.videoList = res.data.videolis;
      this.guidelist = res.data.guidelist;
    });
  },
  methods: {
    moreVideo() {
      var name = "videoList";
      this.$router.push({ name });
    },
    goyuyue() {
      var name = "yuyue";
      this.$router.push({ name });
    },
    go(id) {
      var name = "newsDetail";
      this.$router.push({ name, query: { id } });
    },
    goGuide(id) {
      var name = "guide";
      this.$router.push({ name, query: { id } });
    },
    goDetail(id) {
      var name = "videoDetail";
      this.$router.push({ name, query: { id } });
    },
    // 复制电话
    copyPhone() {
      var input = document.getElementById("input");
      input.value = "0769-38803323"; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$notify({
        title: "已复制联系电话：0769-38803323",
        type: "success",
      });
    },

    backtopClick() {
      $("body,html").animate({ scrollTop: 0 }, 500);
      return false;
    },
    switchTab(name, title) {
      console.log(name);
      // this.backtopClick()
      if (name === 0) {
        newslist(this.form).then((res) => {
          var that = this;
          this.newList = res.data.list;
          that.loading = false;
        });
      } else {
        guideAndVideo().then((res) => {
          this.videoList = res.data.videolis;
          this.guidelist = res.data.guidelist;
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: -10;
}
.new-Bar .bd-holder {
  padding-top: 50%;
}
.new-Bar .bd-content {
  width: calc(100% - 40px);
  margin: 0 auto;
  padding: 0 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 44%;
  background: #56b98e;
  border-radius: 0 0 5px 5px;
  -webkit-transition: 0.4s;
  -o-transition: 0.4s;
  transition: 0.4s;
}
.new .newImg {
  height: 260px;
}
.new .lishu {
  font-family: "Microsoft YaHei";
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
  position: relative;
}
.new .lishu h3 {
  margin: 0;
  padding: 0 10px;
  font-size: 19px;
  font-weight: bold;
  color: #fff;
  line-height: 25px;
}
.new .new-Bar {
  width: calc(100% / 3 - 20px);
  background: #f1ece6;
  float: left;
  margin-right: 20px;
  margin-bottom: 30px;
  border-radius: 5px;
  position: relative;
}
.new .new-Bar:nth-child(3n) {
  margin-right: 0;
}
.new .new-Bar:hover .bd-content {
  height: 100%;
  background-image: url(../../assets/newbg.jpg);
  background-size: 100% 100%;
  border-radius: 5px;
}
.new .new-Bar .content-image {
  display: none;
  opacity: 0;
  transition: all 0.4s;
}
.new .new-Bar:hover .new-title {
  margin-top: 30px;
}
.new .new-Bar:hover .content-image {
  display: inline-block;
  width: 50px;
  opacity: 1;
  margin: 50px calc(50% - 25px) 10px;
}
.new .new-Bar:hover .new-content {
  -webkit-line-clamp: 6;
  height: 129px;
}
.new .new-Bar:hover .getMore {
  text-decoration: underline;
  color: #439392;
  background-color: #fff;
}
.new .new-content {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-indent: 24px;
  height: 44px;
  font-size: 16px;
  color: #f6f6f6;
}
.new .new-title {
  margin-top: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.new .videoBar {
  position: relative;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  box-shadow: 0 0 10px #ddd;
  border-radius: 5px;
}
.new .videoBar img {
  border-radius: 5px;
}
.new .videoBar-title {
  position: absolute;
  width: 100%;
  bottom: 5px;
  left: 0;
  height: 90%;
  color: #fff;
  text-align: center;
  opacity: 0;
  padding: 5px 0;
  font-size: 12px;
}
.new .videoBar-title:hover {
  opacity: 1;
  animation: fade-in;
  animation-duration: 0.5s; /*动画持续时间*/
  -webkit-animation: fade-in 0.5s; /*针对webkit内核*/
}
.new .jiuyi {
  margin: 10px 0;
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  transition: all 0.5s;
  cursor: pointer;
}
.new .jiuyi:hover {
  transform: scale(1.1);
}
.new .getMore {
  margin-top: 24px;
  color: #439392;
  background-color: #fff;
  border: 0;
  font-size: 12px;
  border-radius: 0;
  padding: 0;
  width: 146px;
  height: 30px;
  line-height: 30px;
  transition: all 0.5s;
}
.new .typeClick:hover {
  text-decoration: underline;
}
@media screen and (max-width: 600px) {
  .new .newImg {
    width: 90%;
    margin: 5px auto;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/news/news.vue